// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container___85nz","text":"style_text__Haxni"};